var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebookB = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 12.4989C23.1426 6.74953 18.4764 2.08337 12.7271 2.08337C6.97768 2.08337 2.31152 6.74953 2.31152 12.4989C2.31152 17.54 5.89446 21.7375 10.6439 22.7061V15.6236H8.56084V12.4989H10.6439V9.89502C10.6439 7.88482 12.2792 6.24959 14.2894 6.24959H16.8933V9.37424H14.8102C14.2373 9.37424 13.7686 9.84294 13.7686 10.4158V12.4989H16.8933V15.6236H13.7686V22.8624C19.0284 22.3416 23.1426 17.9046 23.1426 12.4989Z",
    fill: "#001537"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookB, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook_b.72a42742.svg";
export { ForwardRef as ReactComponent };